export default {
  users: [],
  legalEntities: [],
  projects: []
}
